import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileFileDeleteRequest } from '../types/CandidateProfile';

export default function useDeleteCandidateProfilesFile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, fileId }: CandidateProfileFileDeleteRequest) => {
      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/files/${fileId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      return data;
    },
  });
}
